// extracted by mini-css-extract-plugin
export default {"check-box":"lXdl0efZ-e25OK7C3hedyw==","dummy-input":"_2grnwsM67FBysrwJUryRVA=="};